import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-mapped",
  "use": "app-icon-mapped-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-mapped\"><g fill-rule=\"nonzero\" fill=\"none\"><rect fill=\"#2673E5\" width=\"16\" height=\"16\" rx=\"8\" /><path d=\"M4.25 7.25h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5z\" fill=\"#FFF\" /><circle stroke=\"#FFF\" fill=\"#FFF\" cx=\"11.5\" cy=\"7.8\" r=\"1.5\" /><circle stroke=\"#FFF\" fill=\"#2673E5\" cx=\"4.5\" cy=\"7.8\" r=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol